import React, {Fragment} from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
//import EventEmitter from 'react-native-md5'
import 'bootstrap/dist/css/bootstrap.min.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'
const Functions = require('../../shared/Functions.js')
const $ = require('jquery')

const tableStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '25px',
}

const smallStyle = {
  fontSize: 'small',
  color: '#b3b3b3',
}

const iconStyle = {
  paddingLeft: '5px',
}

const dotStyle = {
  height: '15px',
  width: '15px',
  backgroundColor: '#1a1aff',
  borderRadius: '50%',
  display: 'inline-block',
  marginRight: '5px',
}

const dotSeenStyle = {
  height: '15px',
  width: '15px',
  backgroundColor: '#bbb',
  borderRadius: '50%',
  display: 'inline-block',
  marginRight: '5px',
}

const aStyle = {
  display: 'none',
}

class Table extends React.Component {
  constructor(props) {
    super(props)
  }

  renderHeader() {
    return <Fragment><th key="description">Description</th><th key="date">Date</th><th key="read">Read?</th></Fragment>
  }

  renderData() {
    const myData = [].concat(Object.values(this.props.notifications.notifications)).reverse()
    return Object.keys(myData).map((key) => {
      const notification = myData[key]
      const idUrl = 'mylink' + notification['id']
      return <tr key={key} onClick={() => this.handleSubmit(notification['id'].toString(), notification['url'])}><td style={{cursor: 'pointer'}}><a href={notification['url']} id={idUrl} style={aStyle}></a><div className="col-sm-12">{notification['read'] === false &&
                <span style={dotStyle}></span>
              }{notification['read'] === true &&
                <span style={dotSeenStyle}></span>
              }{notification['description']}</div><div className="col-sm-12" style={smallStyle}><FontAwesomeIcon icon={faClock}></FontAwesomeIcon><span style={iconStyle}>{notification['created_at']} ago</span></div></td></tr>
    }
    )
  }

  render() {
    return <div className="row col-md-12"><h2 className="row">All notifications</h2><div className="row justify-content-center align-items-center"><table className="table table-bordered" style={tableStyle}><tbody>{this.renderData()}</tbody></table></div></div>
  }

  handleSubmit(id, url) {
    const urlf = '/notifications/mark_as_accessed/' + id
    const meth = 'POST'
    //const body = JSON.stringify(authenticity_token: Functions.getMetaContent('csrf-token'))
    $.ajax({
      url: urlf,
      dataType: 'JSON',
      method: meth,
      data: { authenticity_token: Functions.getMetaContent('csrf-token') },
    }).done(() => { window.location.href = url } )
  }
}

Table.propTypes = {
  notifications: PropTypes.object,
}

export default Table
